import { Calendar } from "lucide-react";
import type { UpcomingEvent } from "@/api/eventDiscovery";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { googleCalendarUrl, downloadIcs } from "@/lib/calendar";

/** Reusable Add to Calendar dropdown. */
export function CalendarDropdown({
  event,
  className,
}: {
  event: UpcomingEvent;
  className?: string;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className={cn(
            "border-primary/50 text-primary hover:bg-primary/10 hover:text-primary",
            className,
          )}
        >
          <Calendar className="h-4 w-4 mr-2 shrink-0" />
          Add to Calendar
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuItem
          onClick={() =>
            window.open(googleCalendarUrl(event), "_blank", "noopener")
          }
        >
          Google Calendar
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => downloadIcs(event)}>
          Apple / Outlook (.ics)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
